import React, { Component } from "react";
import moment from 'moment';
import ChallengeDetails from '../home/ChallengeDetails';
import ClassFilters from '../home/ClassFilters';
import { bookmarkClass } from  '../../utils/bookmarkClass';
import CancelBooking from '../home/CancelBooking';
import classnames from "classnames";
import { openOnDemandClass } from  '../../utils/openOnDemandClass';
import { openLiveClass } from  '../../utils/openLiveClass';
import { connect } from "react-redux";
import { showMainErrorPop } from '../../actions/popups';

import axiosVirdioT from '../../utils/axios';
var axiosVirdio;

class MarketplaceChallenges extends Component {
  
  constructor(props) {
	super(props);
	
	this.state={
		//chosenOption: (localStorage.getItem('challengeFilters') && JSON.parse(localStorage.getItem('challengeFilters')) && JSON.parse(localStorage.getItem('challengeFilters')).length > 0) ? JSON.parse(localStorage.getItem('onDemandInterest')) : [],
		chosenOption: [1],
		challengeOptions: [ {id: 1, name: 'Challenges', image_icon: './images/challenge_small.svg'}, 
							{id: 2, name: 'Past Challenges', image_icon: './images/challenge_past_small.svg'}],
		allChallenges: [],
		challengesByDate: [],
		sortOptions: ['Most Recent', 'Oldest'],
		chosenSort: 'Most Recent',
		isOpenSort: false,
		groupInfo: {},
		pageCount: 0,
		challengesLength: 0,
		challengesTotalLength: 0,
		hostArrayIds: [],
		isLoadedChallenges: false,
		subCategoryFilter: [],
		chosenSubCategoryFilter: [],
		chosenSubCategoryDataFilter: [],
		isLoadedAllChallenges: false,
		currentUserData: localStorage.getItem('userData') ? JSON.parse(localStorage.getItem('userData')) : {},
		isPopupOpen: false,
		popupMsg: 'You have successfully booked this Challenge'
	}
	
	this.bookmarkClass = bookmarkClass.bind(this);
	this.openOnDemandClass = openOnDemandClass.bind(this);
	this.openLiveClass = openLiveClass.bind(this);
	this.refDetails = React.createRef();
}
 
componentDidMount(){
	axiosVirdio = new axiosVirdioT(this.props);
	this.getChallenges(true, false);
}

getChallenges=(isNewInterest?, runLoader?)=>{
	var sortOption = 0;
	if ( this.state.chosenSort === 'Most Recent' ) { sortOption = 1; }
	if ( this.state.chosenSort === 'Oldest' ) { sortOption = 3; }
	var postData = {
			sortOption: sortOption,
			pageCount: this.state.pageCount, 
			chosenOption: this.state.chosenOption
		};
	
	let token = JSON.parse(localStorage.getItem('userData')).token;
    axiosVirdio.auth(token);
	if ( runLoader )
		{
			this.props.updateStateFromChild({showLoader: true});
		}
	axiosVirdio.get(process.env.REACT_APP_API_URL +'/api/v1/programs/list').then(res => {
		var mainResponse = res.data.responseData;
		if ( runLoader )
			{
				this.props.updateStateFromChild({showLoader: false});
			}
		
		//localStorage.setItem('challengeFilters', JSON.stringify(mainResponse.interestFilterArray));
		this.setState({
			allChallenges : mainResponse.challenges,
			challengesLength: mainResponse.challenges.length,
			challengesTotalLength: mainResponse.challenges.length,
			isLoadedChallenges: true,
			challengesByDate: this.state.chosenOption == 1 ? mainResponse.challenges.upcoming : mainResponse.challenges.previous,
			//chosenOption: mainResponse.interestFilterArray,
			isLoadedAllChallenges: true
		}, ()=>{this.sortClasses(this.state.chosenSort); });
	}).catch(err =>{
		if ( runLoader )
			{
				this.props.updateStateFromChild({showLoader: false});
			}
	});
}

joinChallenge=(challenge_id)=>{
	var mainThis = this;
	axiosVirdio.post(process.env.REACT_APP_API_URL +'/api/v1/programs/joinchallenge', {challenge_id}).then(res => {
		mainThis.openChallengeDetail(challenge_id);
		mainThis.setState({isPopupOpen: true});
		mainThis.getChallenges(false, false);
	})
}

switchOption=(itemId)=>{
	let tempChosenOption = this.state.chosenOption;
	if ( tempChosenOption.indexOf(itemId) > -1 ) { return false; }
	if ( itemId == 1 ) { this.setState({selectedChallenges: this.state.upcomingChallenges})}
	tempChosenOption = [];
	tempChosenOption.push(itemId);
	this.setState({
		chosenOption: tempChosenOption,
		pageCount: 0,
		chosenSubCategoryFilter: [],
		chosenSubCategoryDataFilter: []
	}, ()=> {this.getChallenges(true, true);});
}

openCloseSort=()=>{
	var isOpen = this.state.isOpenSort;
	isOpen = !isOpen;
	this.setState({isOpenSort: isOpen});
}

preventDef=(e)=>{
	e.preventDefault();
	e.stopPropagation();
}

changeSort=(sort)=>{
	if ( !this.state.isLoadedAllChallenges )
		{
			this.setState({
				chosenSort: sort, 
				isOpenSort: false,
				pageCount: 0
			}, () => this.getChallenges(true, true));
		}
	else
		{
			this.setState({
				chosenSort: sort, 
				isOpenSort: false,
			}, () => this.sortClasses(sort));
		}
}

sortClasses=(opt)=>{
	var arrayClasses = this.state.challengesByDate;
	
	if ( opt == 'Most Recent' )
		{
			arrayClasses.sort(function(a, b){ 
				if ( new Date(a.start_date) > new Date(b.start_date) ) { return -1; } 
				if ( new Date(a.start_date) < new Date(b.start_date) ) { return 1; } 
				return 0; 
			})
		}
		
	if ( opt == 'Oldest' )
		{
			arrayClasses.sort(function(a, b){ 
				if ( new Date(a.start_date) < new Date(b.start_date) ) { return -1; } 
				if ( new Date(a.start_date) > new Date(b.start_date) ) { return 1; } 
				return 0; 
			})
		}
	
	arrayClasses.sort(function(a, b){ 
		if (  a.joined > b.joined ) { return -1; }
		if (  b.joined > a.joined ) { return 1; }
		return 0; 
	});
		
	this.setState({challengesByDate: arrayClasses});
}

loadMoreChallenges = ()=>{
	let tempPageCount = this.state.pageCount + 1;
	this.setState({pageCount: tempPageCount
	}, ()=>{this.getChallenges(false, true);});
}

openChallengeDetail=(id)=>{
	var postData = {challenge_id: id};
	let token = JSON.parse(localStorage.getItem('userData')).token;
    axiosVirdio.auth(token);
	axiosVirdio.post(process.env.REACT_APP_API_URL +'/api/v1/programs/info', postData).then(res => {
		this.setState({groupInfo: res.data.responseData.info}, () => this.props.updateStateFromChild({isOpenDetailedClass: true, openedChallengeId: id}));
		this.refDetails.current.updateClassDetails(res.data.responseData.info);
	}).catch(err =>{ });
}

openClass=(id, cType)=>{
	
	if ( this.props && this.props.state && this.props.state.failedPaymentStatus )
		{
			return false;
		}
	
	this.props.updateStateFromChild({showLoader: true});
	
	if ( cType == 'live')
		{
			this.openLiveClass(id);
		}
	else
		{
			this.openLiveClass(id, true);
		}
}

openCancel=(id)=>{
	this.setState({
		classBoking: true, 
		sessionToCancel: id
	});

	this.setState({isOpenCancel: true});
}

openCancelTrigger=()=>{
	if ( this.props.parentComponent == 'mainPage' ) 
		{
			this.setState({isOpenCancel: true});
		}
}

closeCancelTrigger=()=>{
	if ( this.props.parentComponent == 'mainPage' ) 
		{
			this.setState({isOpenCancel: false});
		}
}

updateStateFromChild=(state)=>{
	this.setState(state);
}

resetFilter=()=>{
	this.setState({chosenDurationFilter: [], chosenInstructrosFilter: [], chosenMusicData: [], chosenMusicFilters: [],chosenInstructrosDataFilter: [], chosenSubCategoryFilter: [], chosenSubCategoryDataFilter: [], advancedClassFilter: false, attendedClassFilter: false}, () => {this.applyFilters()});
}

applyFilters=()=>{
	this.getChallenges(true, true);
}

  render() {
	 return (
		<div>
			<div className={classnames({'class_container': true, 'empty_state_component': (this.state.challengesByDate.length == 0 && this.props.parentComponent == 'bookmarkClasses')})}>
				<div className={( this.props.isOpenDetailedClass ? "d-none" : "" )}>
					{ this.props.parentComponent == 'mainPage' &&
						<div className="filter_interest_container">
							<div>
								{ this.state.challengeOptions.map((item, i) =>
									<div key={i} className={"filter_interest ch_option " + ( this.state.chosenOption.indexOf(item.id) > -1 ? "active" : "" )} onClick={() => this.switchOption(item.id)}>
										<div className="interest_icon ch_icon" style={{ backgroundImage: "url("+item.image_icon+")"}}></div>
										<div className={"interest_title challenge_title " + (item.id == 2 ? "ch_title_past" : '')} >{item.name}</div>
									</div>
								)}
							</div>
						</div>
					}
					<div className={"classes_container " + ( ((this.state.challengesByDate.length == 0 && this.state.isLoadedChallenges) ) ? "d-none" : "" )}>
						{ (this.props.parentComponent == 'mainPage' && this.state.challengesByDate.length > 0) &&
							<div className="sort_demand_content">
								<div className="sort_demand" onClick={this.openCloseSort}>
									<div className="sort_demand_title">{this.state.chosenSort}</div>
									<div className={"arrow_down_sort " + ( this.state.isOpenSort ? "active_arrow" : "" )}></div>
									{ this.state.isOpenSort &&
										<div className="sort_container" onClick={this.preventDef}>
											<div className="sort_title">Sort By</div>
											{ this.state.sortOptions.map((item, i) =>
												<div className={"sort_options " + ( this.state.chosenSort == item ? "active" : "" )} key={i} onClick={() => this.changeSort(item)}>{item}
													<div className="checked_sort"></div>
												</div>
											)}
										</div>
									}
								</div>
							</div>
						}
						<div className="classes_holder ch_hold">
							{ this.state.challengesByDate.map((item, i) =>
								<div className={classnames({'class_content': true, 'demand_class_content': true})} key={i} onClick={() => this.openChallengeDetail(item.id)}>
									<div className={'ch_content '+( this.state.chosenOption != 1 || item.joined == 1 ? "ch_no_join" : '')}>
										<div className='ch_content_inner'>
											<div className="class_time">{moment(item.start_date).format('LL')}</div>
											{/*<div className="class_dot ch_dot">&bull;</div>
											<div className="class_time">{moment(item.start_date).format('LT')}</div>*/}
											{ this.state.chosenOption != 1 && item.joined ?
												<div className="ch_detail ch_entered">Entered</div>
												: ''
											}
											{ this.state.chosenOption != 1 && new Date() > new Date(item.start_date).setDate(new Date(item.start_date).getDate() + item.duration) ?
												<div className="ch_detail">Finished</div>
												: ''
											}
											<div className="class_name ch_name">{item.name}</div>
											<div className="class_name ch_description">{item.description}</div>
											<div className="ch_line"></div>
											<div className="ch_props_bottom">
												<div className="ch_props_hold">
													<div className="ch_tab_icon ch_reward_icn"></div>
													<div className="ch_tab_text">${item.reward}</div>
												</div>
												<div className="ch_props_hold">
													<div className="ch_tab_icon ch_classes_icn"></div>
													<div className="ch_tab_text">{item.classes} classes</div>
												</div>
												<div className="ch_props_hold">
													<div className="ch_tab_icon ch_duration_icn"></div>
													<div className="ch_tab_text">{item.duration} Days</div>
												</div>
											</div>
										</div>
									</div>
									{this.state.chosenOption == 1 && item.joined != 1 &&
										<div className="ch_join">
											<div className="ch_join_btn">
												<div className="ch_join_btn_text" onClick={() => this.joinChallenge(item.id)}>Join</div>
											</div>
										</div>
									}
								</div>
							)}
							{ (this.state.challengesTotalLength > this.state.challengesLength && this.state.challengesByDate.length > 0) && 
								<div className="txt_cent_cont">
									<div className="loadMore" onClick={() => this.loadMoreChallenges()}>Load More</div>
								</div>
							}
						</div>
					</div>
					{ this.state.challengesByDate.length == 0 && this.state.isLoadedChallenges && this.props.parentComponent != 'bookmarkClasses' && 
							<div className="empty_state empty_state_schedule">
								<div className={"emptyList" + (this.state.chosenOption == 1 ? " emptyUpcoming" : " emptyPast")}></div>
								<div className="mrgtp26">
									<div className="emptyListTitle ch_emptyList">{this.state.chosenOption == 1 ? "No upcoming challenges" : "No past challenges"}</div>
								</div>
								<div className="mrgtp26">
									<div className="emptyListSub">{this.state.chosenOption == 1 ? "We have no active or upcoming challenges. Check back later for more opportunities to win." :
									"You have not participated in any of our challenges." }
									</div>
								</div>
							</div>
					}
				</div>
			</div>
			<div className={( !this.props.isOpenDetailedClass ? "d-none" : "" )}>
				<ChallengeDetails 
				failedPaymentStatus={(this.props && this.props.state ? this.props.state.failedPaymentStatus : false)}
				groupInfo={this.state.groupInfo} 
				getChallenges={this.getChallenges} 
				updateStateFromChild={this.updateStateFromChild} 
				history={this.props.history}
				openFrom={this.props.parentComponent}
				joinChallenge={this.joinChallenge}	
				openClass={this.openClass}
				openCancelTrigger={this.openCancelTrigger}
				closeCancelTrigger={this.closeCancelTrigger}
				isOpenDetailedClass={this.props.isOpenDetailedClass}
				ref={this.refDetails}></ChallengeDetails>
			</div>
			{ this.state.isPopupOpen &&
				<div>
					  <div className="modal settings_popup_active zindex999999" data-backdrop="static" data-keyboard="false">
						<div className="modal-dialog mw-700 mx-auto modal-dialog-centered">
							<div className="modal-content bg-transparent">
								<div className="modal-body px-4 py-4 modl_bg_drk m-2 radius-8 shadow-none">
									<pre id="login-alert-text" className="py-4 text-light text-center font-20 popup_error_text" dangerouslySetInnerHTML={{__html: this.state.popupMsg}}></pre>
								</div>
								<div className="text-center"><button type="button" className="custom_btn1 mt-3" onClick={() => this.setState({isPopupOpen: false})}>OK</button></div>
							</div>
						</div>
					</div>
				</div>
			}	
		</div>
    );
  }
}

export default connect(
  null,
  { 
	showMainErrorPop
  },
  null,
  {forwardRef: true}
)(MarketplaceChallenges);
